/* Static match data (Kent v Somerset) — structured so real API data can replace it later.
   Each market row: back = [deep2, deep1, best]  lay = [best, deep1, deep2]  (best nearest centre).
   suspended:true renders the red SUSPENDED overlay instead of prices. */
const c = (p, v) => ({ p, v });
/* fancy cell: cls = real Bootstrap class(es) that pick the colour, p = price, v = volume */
const fc = (cls, p, v) => ({ cls, p, v });

export const MATCH = {
  id: 'kent-v-somerset',
  title: 'Kent v Somerset',
  datetime: '(31/07/2026 12:00:00 PM)',
  marquee: "🏆 The Hundred Women's & Men's 🏆 Special Fancy & Cup Winner Market Are Now Available 🏏",

  /* Live scorecard — static now, shaped for a live feed later. teamA = left,
     teamB = right; status.event is the pulsing current-ball label. */
  scorecard: {
    teamA: { name: 'SOM', score: '313/9', overs: '(50.0)', crr: '6.26' },
    teamB: { name: 'KEN', score: '169/2', overs: '(30.5)', crr: '5.48' },
    status: {
      event: 'SINGLE',
      target: 314,
      balls: ['1', '1', '0', '1', '6'],
      text: 'KEN need 145 runs off 115 balls',
      rrr: '7.57',
      batsmen: [
        { name: 'Harry Finch', figures: '18 (15)', striker: true },
        { name: 'Daniel Bell-Drummond', figures: '99 (104)' },
      ],
    },
  },
  markets: [
    {
      id: 'Match_Odds', name: 'Match Odds', minmax: 'Min: 100 | Max: 5k',
      rows: [
        { team: 'Kent', back: [c('1.67', '607.37'), c('1.92', '170.99'), c('1.93', '26.68')], lay: [c('2.52', '402.75'), c('2.6', '12.55'), c('3', '8.4')] },
        { team: 'Somerset', back: [c('1.95', '40.2'), c('1.98', '90.6'), c('2.02', '45.1')], lay: [c('2.06', '33.5'), c('2.62', '9.4'), c('3.05', '6.2')] },
      ],
    },
    {
      id: 'Bookmaker', name: 'Bookmaker', minmax: 'Min: 100 | Max: 25k',
      rows: [
        { team: 'Kent', back: [null, null, c('70', '90')], lay: [c('75', '110'), null, null] },
        { team: 'Somerset', suspended: true, suspendedText: 'SUSPENDED' },
      ],
    },
  ],

  /* Fancy market — a single top-level "Fancy" tab, a row of sub-tabs, and the
     fancy rows. cell.cls carries the real Bootstrap classes: `w-100 lay` = NO
     (pink), `back w-100` = YES (blue); odd/even rows use two blue `back` cells.
     ballRunning:true overlays the red "ball running" panel over the odds. */
  fancy: {
    mainTabs: ['Fancy'],
    subTabs: ['all', 'sessions', 'w/p market', 'odd/even', 'xtra market', 'meter', 'khadda', 'Over by Over'],
    rows: [
      { name: 'Fall of 1st wkt Runs KEN', ballRunning: true, cells: [fc('w-100 lay', '70', '110'), fc('back w-100', '70', '90')] },
      { name: 'D Bell-Drummond Runs', ballRunning: true, cells: [fc('w-100 lay', '54', '110'), fc('back w-100', '54', '90')] },
      { name: 'B Dawkins Runs', ballRunning: true, cells: [fc('w-100 lay', '41', '110'), fc('back w-100', '41', '90')] },
      { name: '6 Over Runs KEN', cells: [fc('w-100 lay', '52', '110'), fc('back w-100', '54', '90')] },
      { name: '10 Over Runs KEN', cells: [fc('w-100 lay', '88', '110'), fc('back w-100', '90', '90')] },
      { name: '20 Over Odd Even Run Bhav KEN', cells: [fc('w-100 back', '1.96', '25000'), fc('back w-100', '1.96', '25000')] },
      { name: '30 Over Odd Even Run Bhav KEN', cells: [fc('w-100 back', '1.96', '25000'), fc('back w-100', '1.96', '25000')] },
      { name: '35 Over Odd Even Run Bhav KEN', cells: [fc('w-100 back', '1.96', '25000'), fc('back w-100', '1.96', '25000')] },
      { name: '40 Over Odd Even Run Bhav KEN', cells: [fc('w-100 back', '1.96', '25000'), fc('back w-100', '1.96', '25000')] },
    ],
  },

  /* "Last Digit" — a back-only market (single best-back cell, two hidden
     spacer cells keep it aligned under the BACK header). */
  lastDigit: {
    title: '20 Over KEN Last Digit',
    minmax: 'Min: 100 | Max: 50k',
    rows: Array.from({ length: 10 }, (_, n) => ({ name: `${n} Number`, ...c('9.80', '50k') })),
  },
};
